<template>
  <div class="right">
    <div class="top_box">
      <span class="title">{{ headerTitle }}</span>
      <button type="button" class="btn_close" :aria-label="$t('whatsapp.drawer.close')" @click="handleClickClose">
        <img src="@/modules/whatsapp/img/wa_close.png" alt=""/>
      </button>
    </div>
    <div ref="bottomScrollRef" class="bottom_scroll" @scroll="handleBottomScroll">
    <!-- 联系人信息模式才展示头像区域 -->
      <div v-if="mode === 'contact'" class="middle">
        <div class="avatar_wrap">
          <el-image
              v-if="hasRoomAvatar"
              class="avatar"
              :src="resolvedRoomAvatar"
              fit="cover"
          >
            <template #error>
              <div class="avatar_placeholder"/>
            </template>
          </el-image>
          <div v-else class="vac-avatar" :style="{ 'background-image': `url('${fallbackRoomAvatarUrl}')` }" />
        </div>
        <div class="username">{{ displayName }}</div>
        <div class="userid">
          <span>{{ displayNumber }}</span>
        </div>
      </div>    
      <div class="bottom" :class="{ 'bottom--no-top-padding': mode === 'media', 'bottom--search': mode === 'search' }">
        <!-- 1. 联系人信息（设计图 1） -->
        <template v-if="mode === 'contact'">
          <!-- v-if="hasMediaDocsLinks" -->
          <div v-if="hasMediaDocsLinks" class="contact-card" @click="$emit('change-mode', 'media')">
            <div class="section_header">
              <span class="section_title">{{ $t('whatsapp.drawer.mediaDocsLinks') }}</span>
              <span class="section_count">{{ mediaCount }}</span>
            </div>
            <div class="thumb_list">
              <div
                  v-for="(item, index) in displayThumbList"
                  :key="index"
                  class="thumb_item"
                  :class="{ 'thumb_item_video': isVideo(item), 'thumb_item_clickable': isThumbClickable(item) }"
                  @click.stop="handleThumbClick(item)"
              >
              <div
                  v-if="isImage(item)"
                  class="thumb_img"
                  :style="thumbStyle(item)"
              />
                <div v-else-if="isVideo(item)" class="thumb_video">
                  <svg class="play_icon" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" fill="rgba(0,0,0,0.35)"/>
                    <path d="M10 8l6 4-6 4V8z" fill="#fff"/>
                  </svg>
                </div>
                <div v-else-if="isLink(item)" class="thumb_file">
                  <div class="thumb_file_content">
                    <div class="thumb_file_icon thumb_link_icon">
                      <img
                        class="thumb_link_favicon"
                        :src="getFaviconUrl(item?.url || item?.text)"
                        alt=""
                        @error="handleThumbFaviconError"
                      />
                    </div>
                    <div class="thumb_file_main">
                      <div class="thumb_file_title">{{ getThumbTitle(item) }}</div>
                      <div class="thumb_file_sub">{{ getThumbSub(item) }}</div>
                    </div>
                  </div>
                </div>
                <div v-else class="thumb_file">
                  <div class="thumb_file_content">
                    <div class="thumb_file_icon">
                      <FileIcon
                        :fileExtend="getFileExtFromNameOrUrl(item?.name || item?.title, item?.url || item?.text)?.toLocaleLowerCase()"
                        :fileUrl="item?.url || item?.text"
                        :size="28"
                        :isAbbreviation="true"
                      />
                    </div>
                    <div class="thumb_file_main">
                      <div class="thumb_file_title">{{ getThumbTitle(item) }}</div>
                      <div class="thumb_file_sub">{{ getThumbSub(item) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- 2. 搜索信息（设计图 2） -->
        <SearchInfoPanel
            v-else-if="mode === 'search'"
            ref="searchPanelRef"
            :key="room?.roomId || ''"
            :results="searchResults"
            :messages-loaded="messagesLoaded"
            :use-external-scroll="true"
            @load-more-history="handleLoadMoreHistory"
            @select-result="handleLocateMessage"
        />

        <!-- 3. 客户详情（设计图 3） -->
        <CustomerInfoPanel
            v-else-if="mode === 'customer'"
            :customer="customer"
        />

        <!-- 4. 影音内容、文档和链接详情（设计图 4/5/6） -->
        <div v-else-if="mode === 'media'" class="media-panel-wrapper">
          <MediaDocsLinksPanel
              :compact="true"
              :media-list="mediaList"
              :chat-id="room?.roomId || ''"
              @open-all="handleOpenAll"
              @preview-media="handlePreviewMedia"
          />
        </div>

        <!-- 接入 WhatsApp 提升沟通效率（归档对话） -->
        <WhatsAppIntegrationPanel
            v-else-if="mode === 'archive' && !isGroupRoom && !isMyCustomer"
            @archive="handleClickReturnCustomer"
        />

        <!--  归档对话-->
        <ReturnEmails ref="emailsReturn"
                      v-if="dialogVisible"
                      v-model="dialogVisible"
                      @close="close"
                      @archive-success="handleArchiveSuccess"
                      @createCustomer="[]"
                      :targetEmail="[]"
                      :reGetList="[]"
                      :isWhatsApp="true"
                      :npId="displayNumber"
        ></ReturnEmails>

        <div v-if="isGroupRoom && mode === 'contact'" class="group_user_list_settings">
          <div class="user_list" ref="userListRef" @scroll="handleUserListScroll">
            <div v-for="(u, idx) in groupMembers" :key="u?.id?._serialized || u?.id?.user || u?.id || u?._id || u?.uid || idx" class="member_item">
              <div class="member_left">
                <div class="member_avatar_wrap">
                  <el-image
                      v-if="u?.avatar || u?.avatarUrl || u?.profilePicUrl || u?.picture"
                      class="member_avatar"
                      :src="u?.avatar || u?.avatarUrl || u?.profilePicUrl || u?.picture"
                      fit="cover"
                  >
                    <template #error>
                      <div class="member_avatar_placeholder"/>
                    </template>
                  </el-image>
                  <div v-else class="member_avatar_placeholder"/>
                </div>
                <div class="member_text">
                  <div class="member_name">{{ u?.name || u?.username || u?.pushName || u?.verifiedName || u?.id?.user || '—' }}</div>
                  <div class="member_sub">{{ u?.abo || u?.desc || u?.signature || u?.statusText || u?.about || '' }}</div>
                </div>
              </div>
              <div class="member_right">
                <div v-if="hasAdminBadge(u)" class="member_admin_badge">
                  {{ getMemberAdminBadge(u) }}
                </div>
                <div class="member_id">{{ normalizeWaId(u?.pn || u?.id?._serialized || u?.id?.user || u?.id || u?._id || u?.uid || '') }}</div>
              </div>
            </div>
          </div>
          <div class="setting_tool">
            <ul class="action_list">
              <!-- <li class="action_item" @click="handleGroupAction('add-special')">
               <svg class="action_icon icon" t="1773914847602" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3868" id="mx_n_1773914847603" width="20" height="20"><path d="M512 916.603c-16.582 0-31.291-4.428-44.969-13.538l-3.062-2.039-1.946-1.947c-1.558-1.332-5.849-4.849-10.01-8.261-23.233-19.045-77.639-63.645-134.891-117.33-72.301-67.797-124.967-127.34-156.544-176.986-16.095-24.157-32.775-50.805-45.887-81.948-15.94-37.858-23.688-75.257-23.688-114.333 0-70.88 25.586-137.938 72.044-188.821 22.888-25.068 49.586-44.804 79.352-58.658 31.185-14.516 64.288-21.875 98.388-21.875 37.008 0 74.488 9.248 108.388 26.745 23.061 11.902 44.604 27.695 63.552 46.474 45.263-46.359 106.81-73.219 170.484-73.219 34.1 0 67.202 7.36 98.387 21.875 29.766 13.854 56.464 33.59 79.353 58.658 46.46 50.883 72.046 117.941 72.046 188.821 0 83.49-36.729 143.023-63.548 186.493-1.859 3.014-3.689 5.979-5.475 8.901l-0.161 0.26c-86.218 138.47-303.006 304.381-305.157 305.994l-0.825 0.619-0.858 0.572c-13.675 9.113-28.386 13.543-44.973 13.543z m-50.601-18.149l0.107 0.107-0.107-0.107z m48.121-56.121c0.571 0.222 1.198 0.271 2.48 0.271 1.745 0 2.273-0.09 3.102-0.583 14.581-11.26 210.39-164.119 285.805-285.116 1.816-2.97 3.675-5.984 5.564-9.046 24.621-39.907 52.526-85.138 52.526-147.638 0-107.719-78.857-195.354-175.786-195.354-51.832 0-101.908 26.305-133.952 70.366l-1.047 1.44-34.25 38.662-35.126-37.936-1.008-1.305c-34.977-45.266-84.926-71.227-137.042-71.227-96.928 0-175.784 87.636-175.784 195.354 0 64.146 28.343 112.028 57.374 155.574l0.454 0.698c44.561 70.214 137.453 163.443 276.097 277.097 5.282 4.33 8.46 6.939 10.593 8.743z" fill="#6e6e6e" p-id="3869"></path></svg>
                <span class="action_text">{{ $t('whatsapp.drawer.addToSpecialAttention') }}</span>
              </li>
              <li class="action_item" @click="handleGroupAction('add-list')">
                <svg class="action_icon icon" t="1773914897912" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4882" width="20" height="20"><path d="M490.666667 170.666667a149.333333 149.333333 0 1 0 0 298.666666 149.333333 149.333333 0 0 0 0-298.666666zM256 320a234.666667 234.666667 0 1 1 469.333333 0 234.666667 234.666667 0 0 1-469.333333 0zM341.333333 682.666667a170.666667 170.666667 0 0 0-170.666666 170.666666h332.8v85.333334H85.333333v-85.333334a256 256 0 0 1 256-256h160v85.333334H341.333333z m245.333334-85.333334h362.666666v85.333334h-362.666666v-85.333334z m0 128h362.666666v85.333334h-362.666666v-85.333334z m0 128h362.666666v85.333334h-362.666666v-85.333334z" fill="#7d7d7d" p-id="4883"></path></svg>
                <span class="action_text">{{ $t('whatsapp.drawer.addToList') }}</span>
              </li> -->
              <!-- <li class="action_item danger" @click="handleGroupAction('clear-chat')">
                <svg t="1773915041468" class="action_icon icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8683" width="20" height="20"><path d="M512 42.666667c259.2 0 469.333333 210.133333 469.333333 469.333333s-210.133333 469.333333-469.333333 469.333333S42.666667 771.2 42.666667 512 252.8 42.666667 512 42.666667z m0 64C288.149333 106.666667 106.666667 288.149333 106.666667 512s181.482667 405.333333 405.333333 405.333333 405.333333-181.482667 405.333333-405.333333S735.850667 106.666667 512 106.666667z m183.466667 362.666666c4.693333 0 8.533333 3.84 8.533333 8.533334v46.933333a8.533333 8.533333 0 0 1-8.533333 8.533333H349.866667a8.533333 8.533333 0 0 1-8.533334-8.533333v-46.933333c0-4.693333 3.84-8.533333 8.533334-8.533334h345.6z" fill="#b2354e" p-id="8684"></path></svg>
                <span class="action_text">{{ $t('whatsapp.drawer.clearChat') }}</span>
              </li> -->
              <li class="action_item danger" @click="handleGroupAction('exit-group')">
                <svg t="1773915169938" class="action_icon icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11902" width="20" height="20"><path d="M512 896a32 32 0 0 1-28.272 31.792L480 928l-256 0a96 96 0 0 1-95.84-90.352L128 832 128 192a96 96 0 0 1 90.352-95.84L224 96 480 96a32 32 0 0 1 3.728 63.792L480 160l-256 0a32 32 0 0 0-31.792 28.272L192 192l0 640a32 32 0 0 0 28.272 31.792L224 864 480 864a32 32 0 0 1 32 32z" fill="#a92436" p-id="11903"></path><path d="M896 480m0 32l0 0q0 32-32 32l-512 0q-32 0-32-32l0 0q0-32 32-32l512 0q32 0 32 32Z" fill="#a92436" p-id="11904"></path><path d="M886.624 489.376a32 32 0 0 1-42.24 47.92l-3.008-2.672-160-160a32 32 0 0 1 42.24-47.92l3.008 2.672 160 160z" fill="#a92436" p-id="11905"></path><path d="M886.624 534.624a32 32 0 0 0-42.24-47.92l-3.008 2.672-160 160a32 32 0 0 0 42.24 47.92l3.008-2.672 160-160z" fill="#a92436" p-id="11906"></path></svg>
                <span class="action_text">{{ $t('whatsapp.drawer.leaveGroup') }}</span>
              </li>
              <!-- <li class="action_item danger" @click="handleGroupAction('report-group')">
                <svg t="1773915237541" class="action_icon icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13863" width="20" height="20"><path d="M916.945455 463.127273c2.327273-11.636364 4.654545-18.618182 9.30909-25.6 9.309091-13.963636 18.618182-32.581818 16.29091-69.818182-2.327273-34.909091-16.290909-48.872727-25.6-62.836364-4.654545-6.981818-9.309091-11.636364-13.963637-20.945454-4.654545-11.636364-4.654545-18.618182-4.654545-30.254546 0-13.963636 0-30.254545-13.963637-55.854545-9.309091-18.618182-23.272727-27.927273-32.581818-34.909091-9.309091-6.981818-13.963636-11.636364-18.618182-23.272727-13.963636-41.890909-41.890909-69.818182-76.8-69.818182H442.181818c-13.963636 0-23.272727 9.309091-23.272727 23.272727s9.309091 23.272727 23.272727 23.272727h314.181818c13.963636 0 25.6 18.618182 30.254546 39.563637 6.981818 25.6 23.272727 37.236364 34.909091 46.545454 6.981818 6.981818 13.963636 11.636364 20.945454 20.945455 6.981818 13.963636 9.309091 20.945455 9.309091 32.581818 0 11.636364 0 25.6 9.309091 46.545455 6.981818 16.290909 13.963636 25.6 20.945455 32.581818 9.309091 11.636364 13.963636 16.290909 16.290909 37.236363 2.327273 23.272727-2.327273 30.254545-9.309091 41.890909-4.654545 9.309091-13.963636 20.945455-16.290909 41.89091-4.654545 25.6 2.327273 39.563636 6.981818 51.2 2.327273 6.981818 4.654545 11.636364 4.654545 18.618181 0 48.872727-32.581818 55.854545-51.2 55.854546h-197.818181c-6.981818 0-16.290909 4.654545-20.945455 11.636363-4.654545 6.981818-4.654545 16.290909 0 23.272728 0 0 51.2 102.4 37.236364 207.127272-6.981818 55.854545-41.890909 74.472727-62.836364 79.127273-23.272727 6.981818-44.218182 4.654545-55.854545-4.654545s-11.636364-18.618182-13.963637-58.181818c0-20.945455-2.327273-46.545455-6.981818-79.127273-11.636364-83.781818-62.836364-144.290909-155.927273-181.527273-34.909091-13.963636-37.236364-34.909091-37.236363-72.145454V141.963636c0-39.563636-32.581818-72.145455-72.145455-72.145454H104.727273c-13.963636...[980 bytes truncated]"></path></svg>
                <span class="action_text">{{ $t('whatsapp.drawer.reportGroup') }}</span>
              </li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>

    <MediaDocsLinksDialog
        v-model="showAllDialog"
        :default-tab="allDialogTab"
        :is-all-mode="true"
        @preview-media="handlePreviewMedia"
    />
  </div>
</template>

<script>
import {isImageFile, isVideoFile} from '@/modules/whatsapp/utils/media-file'
import {getGroupParticipants, getWhatsAppExtendList} from '@/api/whatsapp.js'
import 'viewerjs/dist/viewer.css'
import { api as viewerApi } from 'v-viewer'
import SearchInfoPanel from './panels/SearchInfoPanel.vue'
import MediaDocsLinksPanel from './panels/MediaDocsLinksPanel.vue'
import CustomerInfoPanel from './panels/CustomerInfoPanel.vue'
import WhatsAppIntegrationPanel from './panels/WhatsAppIntegrationPanel.vue'
import MediaDocsLinksDialog from './MediaDocsLinksDialog.vue'
import ReturnEmails from "@/components/DiaPops/Returns/ReturnEmails.vue";
import FileIcon from "@/components/File/FileIcon.vue";
import defaultGroupAvatar from '@/modules/whatsapp/img/default_group_avatar.svg'
import defaultUserAvatar from '@/modules/whatsapp/img/default_user_avatar.svg'
import {Storage} from '@/utils/storage'
import whatsappOfficialAvatar from '@/assets/960px-WhatsApp.svg.webp'

export default {
  name: "Drawer",
  components: {
    ReturnEmails,
    SearchInfoPanel,
    MediaDocsLinksPanel,
    CustomerInfoPanel,
    WhatsAppIntegrationPanel,
    MediaDocsLinksDialog,
    FileIcon,
  },
  props: {
    mode: {
      type: String,
      default: 'contact',
      validator: v => ['contact', 'search', 'customer', 'media', 'archive'].includes(v)
    },
    currentUserId: {
      type: String,
      default: ''
    },
    room: {
      type: Object,
      default: () => ({})
    },
    mediaList: {
      type: Array,
      default: () => []
    },
    messages: {
      type: Array,
      default: () => []
    },
    messagesLoaded: {
      type: Boolean,
      default: true
    },
    customer: {
      type: Object,
      default: null
    }
  },
  emits: ['closeDraw', 'preview-media', 'archive', 'archive-success', 'change-mode', 'room-action-handler', 'load-more-history', 'locate-message'],
  data() {
    return {
      dialogVisible: false,
      showAllDialog: false,
      allDialogTab: 'media',
      groupMembersList: [],
      loadingGroupMembers: false,
      groupMembersPage: 1,
      groupMembersHasMore: true,
      groupMembersLimit: 10,

      recentThumbs: [],
      recentThumbsTotal: null,
      loadingRecentThumbs: false,
      recentThumbsReqKey: '',
			searchScrollLock: false
    }
  },
  computed: {
    normalizeWaId() {
      return (v) => {
        const s = String(v || '').trim()
        if (!s) return ''
        if (s.includes('@g.us')) return ''
        return s.replace(/@.*$/, '')
      }
    },
    isGroupRoom() {
      if (this.room?.isGroup === true) return true
      if (this.room?.type === 'group') return true
      const rid = this.room?.roomId
      return typeof rid === 'string' ? rid.includes('@g.us') : false
    },
    isOfficialRoom() {
      const rid = String(this.room?.roomId || '').trim()
      return rid === '0@c.us'
    },
    isMyCustomer() {
      return this.room?.contactInfo?.isMyCustomer === true
    },
    hasRoomAvatar() {
      if (this.isOfficialRoom) return true
      const avatar = this.room?.avatar
      return typeof avatar === 'string' && avatar.trim().length > 0
    },
    resolvedRoomAvatar() {
      if (this.isOfficialRoom) return whatsappOfficialAvatar
      const avatar = this.room?.avatar
      if (typeof avatar === 'string' && avatar.trim()) return avatar
      return this.isGroupRoom ? this.groupAvatarUrl : this.userAvatarUrl
    },
    fallbackRoomAvatarUrl() {
      if (this.isOfficialRoom) return whatsappOfficialAvatar
      return this.isGroupRoom ? this.groupAvatarUrl : this.userAvatarUrl
    },
    groupAvatarUrl() {
      // 使用计算属性确保有有效的 fallback
      return defaultGroupAvatar || '/src/modules/whatsapp/img/default_group_avatar.svg'
    },
    userAvatarUrl() {
      return defaultUserAvatar || '/src/modules/whatsapp/img/default_user_avatar.svg'
    },
    groupMembers() {
      // 优先使用接口获取的成员列表
      if (this.groupMembersList.length > 0) {
        return this.groupMembersList
      }
      // 降级使用 room 中的成员数据
      const r = this.room || {}
      const list = r.groupUsers || r.participants || r.members || r.users || []
      return Array.isArray(list) ? list : []
    },
    headerTitle() {
      const map = {
        contact: this.$t('whatsapp.drawer.contactInfo'),
        search: this.$t('whatsapp.drawer.searchInfo'),
        customer: this.$t('whatsapp.drawer.customerInfo'),
        media: this.$t('whatsapp.drawer.mediaDocsLinks'),
        archive: this.$t('whatsapp.drawer.archiveTitle')
      }
      return map[this.mode] || this.$t('whatsapp.drawer.contactInfo')
    },
    contactInfo() {
      return this.room?.contactInfo || null
    },
    displayName() {
      if (this.isOfficialRoom) return 'WhatsApp'
      const info = this.contactInfo
      console.log(info,"displayName")
      const name = String(  info?.name ||info?.pushname|| '').trim()
      if (name) return name
      return this.room?.roomName || '—'
    },
    displayNumber() {
      if (this.isOfficialRoom) return '官方'
      const info = this.contactInfo
      const n = String(info?.number || '').trim()
      if (n) return n
      const rid = this.room?.roomId || this.room?._id || this.room?.phone || ''
      return this.normalizeWaId(rid) || '—'
    },
    displayId() {
      const info = this.contactInfo
      const id = String(info?.id || '').trim()
      if (id) return id
      return this.room?.roomId || this.room?._id || this.room?.phone || '—'
    },
    searchResults() {
      if (!this.messages || this.messages.length === 0) {
        return this.placeholderSearchResults
      }
      const list = this.messages
          .filter(m => m && m.content && typeof m.content === 'string')
          .map((m, index) => {
            const ts = Number(m.timestamp || m.ts || m.time || 0)
            const messageId = m._id || m.id || ''
            return {
              _id: messageId || `${ts || '0'}_${index}`,
              messageId,
              timestamp: ts,
              date: m.date || this.formatMessageDate(ts),
              content: m.content
            }
          })

      // 搜索信息：展示最新在最上面（倒序）
      // 注意：messages 本身在聊天窗口里是正序展示，这里需要独立排序
      list.sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0))

      return list
    },
    placeholderSearchResults() {
      return [
        {date: '09/15', content: this.$t('whatsapp.drawer.placeholder.searchResult')},
        {date: '09/14', content: this.$t('whatsapp.drawer.placeholder.searchResult')},
        {date: '09/13', content: this.$t('whatsapp.drawer.placeholder.searchResult')}
      ]
    },
    hasMediaDocsLinks() {
      if (typeof this.recentThumbsTotal === 'number') {
        return this.recentThumbsTotal > 0
      }
      return (this.recentThumbs?.length || 0) > 0 || (this.mediaList?.length || 0) > 0
    },
    mediaCount() {
      if (typeof this.recentThumbsTotal === 'number') return this.recentThumbsTotal
      return this.mediaList.length > 0 ? this.mediaList.length : 0
    },
    displayThumbList() {
      if (this.recentThumbs.length > 0) {
        return this.recentThumbs.slice(0, 3)
      }
      if (this.mediaList.length > 0) {
        return this.mediaList.slice(0, 3)
      }
      return []
    },
    placeholderMedia() {
      return [
        {type: 'image/png', url: 'https://picsum.photos/400/400?random=drawer1'},
        {type: 'image/jpeg', url: 'https://picsum.photos/400/400?random=drawer2'},
        {type: 'video/mp4', url: ''}
      ]
    }
  },
  watch: {
    room: {
      immediate: true,
      handler(newVal) {
        this.recentThumbs = []
        this.recentThumbsTotal = null
        this.fetchRecentThumbs(newVal)

        // 重置分页状态
        this.groupMembersPage = 1
        this.groupMembersHasMore = true
        this.groupMembersList = []

        if (newVal?.roomId && this.isGroupRoom) {
          this.fetchGroupParticipants(newVal.roomId, false)
        }
      }
    }
  },

  methods: {
		normalizeFromUsId(value) {
			const s = String(value || '').trim()
			if (!s) return ''
			if (s.endsWith('@c.us')) return s
			const m = s.match(/^(\d+)/)
			if (m && m[1]) return `${m[1]}@c.us`
			return s
		},
		handleBottomScroll(e) {
			if (this.mode !== 'search') return
			const target = e?.target
			if (!target) return

			const scrollBottom = target.scrollTop + target.clientHeight
			if (scrollBottom < target.scrollHeight - 20) return
			if (this.searchScrollLock) return

			this.searchScrollLock = true
			this.$nextTick(() => {
				this.$refs.searchPanelRef?.onReachBottom?.()
			})
			setTimeout(() => {
				this.searchScrollLock = false
			}, 300)
		},
    getFileExtFromNameOrUrl(name, url) {
      const n = String(name || '').trim()
      if (n && n.includes('.')) {
        const ext = n.split('.').pop()
        return String(ext || '').toLowerCase()
      }
      const u = String(url || '').split('?')[0].split('#')[0].trim()
      if (!u) return ''
      const last = u.lastIndexOf('.')
      if (last === -1) return ''
      return u.slice(last + 1).toLowerCase()
    },
    getFileSize(size) {
      const n = Number(size || 0)
      if (!isFinite(n) || n <= 0) return ''
      const kb = 1024
      const mb = kb * 1024
      const gb = mb * 1024
      if (n >= gb) return `${(n / gb).toFixed(1)}GB`
      if (n >= mb) return `${(n / mb).toFixed(1)}MB`
      if (n >= kb) return `${Math.round(n / kb)}KB`
      return `${n}B`
    },
    getThumbTitle(item) {
      const it = item || {}
      const title = String(it?.name || it?.title || it?.fileName || it?.filename || '').trim()
      if (title) return title
      const ext = this.getFileExtFromNameOrUrl('', it?.url)
      return ext ? `${ext.toUpperCase()} ${this.$t('whatsapp.drawer.doc')}` : this.$t('whatsapp.drawer.doc')
    },
    getThumbSub(item) {
      const it = item || {}
      if (this.isLink(it)) {
        return this.getLinkHost(this.normalizeLinkUrl(it?.url || it?.text) || '') || ''
      }
      const ext = this.getFileExtFromNameOrUrl(it?.name || it?.title, it?.url || it?.text)
      const size = this.getFileSize(it?.extendSize || it?.size)
      const left = ext ? ext.toUpperCase() : this.$t('whatsapp.drawer.doc')
      return size ? `${left}·${size}` : left
    },
    extractFirstHttpUrl(input) {
      const str = String(input || '')
      if (!str) return ''
      const m1 = str.match(/https?:\/\/[\S]+/i)
      if (m1 && m1[0]) return String(m1[0]).replace(/[),.，。；;]+$/g, '')
      const m2 = str.match(/\b(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+(?:\/[\S]*)?/)
      if (m2 && m2[0]) return String(m2[0]).replace(/[),.，。；;]+$/g, '')
      return ''
    },
    normalizeLinkUrl(url) {
      const s = String(url || '').trim()
      if (!s) return ''
      if (/^(javascript|data|vbscript):/i.test(s)) return ''
      if (/[\s]/.test(s)) return ''
      if (s.startsWith('http://') || s.startsWith('https://')) return s
      const domainLike = /^[a-zA-Z0-9.-]+(?::\d+)?(?:\/.*)?$/.test(s)
      if (!domainLike) return ''
      return `https://${s}`
    },
    getLinkHost(url) {
      try {
        const u = new URL(String(url || ''))
        return u.host || ''
      } catch (e) {
        return ''
      }
    },
    getFallbackFavicon() {
      return 'data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%23999%22%20stroke-width%3D%222%22%3E%3Cpath%20d%3D%22M10%2013a5%205%200%200%200%207.54.54l3-3a5%205%200%200%200-7.07-7.07l-1.72%201.71%22/%3E%3Cpath%20d%3D%22M14%2011a5%205%200%200%200-7.54-.54l-3%203a5%205%200%200%200%207.07%207.07l1.71-1.71%22/%3E%3C/svg%3E'
    },
    getFaviconUrl(url) {
      const extracted = this.extractFirstHttpUrl(url)
      const normalized = this.normalizeLinkUrl(extracted || url)
      if (!normalized) return this.getFallbackFavicon()
      const host = this.getLinkHost(normalized)
      if (!host) return this.getFallbackFavicon()
      return `https://icons.duckduckgo.com/ip3/${host}.ico`
    },
    handleThumbFaviconError(e) {
      const el = e?.target
      if (!el) return
      const fallback = this.getFallbackFavicon()
      if (el.src === fallback) return
      if (String(el.src || '').includes('icons.duckduckgo.com/ip3/')) {
        const u = String(el.src || '')
        const m = u.match(/\/ip3\/([^/]+)\.ico/i)
        const host = m && m[1] ? m[1] : ''
        if (host) {
          el.src = `https://www.google.com/s2/favicons?domain=${encodeURIComponent(host)}&sz=64`
          return
        }
      }
      el.src = fallback
    },
    isOfficePreviewableExt(ext) {
      const e = String(ext || '').toLowerCase()
      return ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(e)
    },
    getUrlPathExt(url) {
      try {
        const u = new URL(String(url || ''))
        const pathname = String(u.pathname || '')
        const seg = pathname.split('/').filter(Boolean).pop() || ''
        if (!seg || !seg.includes('.')) return ''
        const ext = seg.split('.').pop() || ''
        return String(ext).toLowerCase()
      } catch (e) {
        return ''
      }
    },
    isLink(item) {
      const it = item || {}
      if (it?.type === 'link') return true
      const raw = String(it?.text || it?.url || '').trim()
      if (!raw) return false
      if (this.isImage(it) || this.isVideo(it)) return false
      const extracted = this.extractFirstHttpUrl(raw)
      const normalized = this.normalizeLinkUrl(extracted || raw)
      if (!normalized) return false
      // Only treat as file when URL PATH ends with ext; do not treat .com as file ext.
      const pathExt = this.getUrlPathExt(normalized)
      if (pathExt) return false
      return true
    },
    isThumbClickable(item) {
      if (!item) return false
      if (this.isImage(item) || this.isVideo(item)) return true
      const url = String(item?.url || item?.text || '')
      return !!url
    },
    inferMimeTypeFromUrl(url) {
      const s = String(url || '').split('?')[0].split('#')[0].toLowerCase()
      const ext = s.includes('.') ? s.slice(s.lastIndexOf('.') + 1) : ''
      const imageExt = {
        png: 'image/png',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        gif: 'image/gif',
        webp: 'image/webp',
        bmp: 'image/bmp',
        svg: 'image/svg+xml'
      }
      const videoExt = {
        mp4: 'video/mp4',
        webm: 'video/webm',
        mov: 'video/quicktime',
        m4v: 'video/x-m4v'
      }
      if (imageExt[ext]) return imageExt[ext]
      if (videoExt[ext]) return videoExt[ext]
      return ''
    },
    normalizeRecentThumbItem(item) {
      const rawUrl = item?.url || item?.extendUrl || item?.fileUrl || item?.path || item?.text || ''
      const extracted = this.extractFirstHttpUrl(rawUrl)
      const normalizedLink = this.normalizeLinkUrl(extracted || rawUrl)

      // Link vs file: if normalized link exists and URL PATH has no extension -> treat as link
      if (normalizedLink && !this.getUrlPathExt(normalizedLink)) {
        return {
          ...item,
          url: normalizedLink,
          type: 'link',
          text: item?.text || rawUrl
        }
      }

      const url = String(rawUrl || '').trim()
      const rawType = item?.mimeType || item?.contentType || item?.extendType || item?.type
      const type = typeof rawType === 'string' && rawType ? rawType : this.inferMimeTypeFromUrl(url)
      return {
        ...item,
        url,
        type
      }
    },
    fetchRecentThumbs(room) {
      const chatId = room?.roomId || room?._id || ''
      if (!chatId) return
      if (typeof getWhatsAppExtendList !== 'function') return

      const reqKey = `${chatId}`
      if (this.loadingRecentThumbs && this.recentThumbsReqKey === reqKey) return
      this.recentThumbsReqKey = reqKey
      this.loadingRecentThumbs = true

      // type: 1 代表媒体（图片/视频），这里只需要最近三条缩略位
      const params = {
        chatId,
        pageSize: 3,
        page: 1,
        current: 1,
        size: 3
      }

      getWhatsAppExtendList(params)
        .then((res) => {
          const payload = res?.result || res?.data?.result || res?.data || res
          const records = payload?.records || payload?.list || payload?.rows || payload?.data || []
          const list = Array.isArray(records) ? records : []
          const total = payload?.total
          const normalized = list.map(this.normalizeRecentThumbItem)
          // 防止并发切换 room 后写错
          const currentChatId = this.room?.roomId || this.room?._id || ''
          if (String(currentChatId) === String(chatId)) {
            this.recentThumbs = normalized
            if (typeof total === 'number') {
              this.recentThumbsTotal = total
            }
          }
        })
        .catch(() => {
          // ignore
        })
        .finally(() => {
          const currentChatId = this.room?.roomId || this.room?._id || ''
          if (String(currentChatId) === String(chatId)) {
            this.loadingRecentThumbs = false
          }
        })
    },
    close() {
      this.dialogVisible = false
    },
    handleArchiveSuccess() {
      this.$emit('archive-success', { roomId: this.room?.roomId })
    },
    handleClickReturnCustomer() {
      this.dialogVisible = true
    },
    handleClickClose() {
      this.$emit('closeDraw')
    },
    handleLoadMoreHistory() {
      this.$emit('load-more-history')
    },
    handleLocateMessage(item) {
      if (!item) return
      this.$emit('locate-message', item)
    },
    formatMessageDate(timestamp) {
      if (timestamp == null) return ''
      const d = new Date(timestamp)
      if (isNaN(d.getTime())) return String(timestamp)
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${m}/${day}`
    },
    isImage(file) {
      return file && isImageFile(file)
    },
    isVideo(file) {
      return file && isVideoFile(file)
    },
    thumbStyle(file) {
      const url = file?.url || file?.preview
      if (!url) return {}
      return {backgroundImage: `url('${url}')`}
    },
    handlePreviewMedia(file) {
      this.$emit('preview-media', file)
    },
    handleOpenAll(tab) {
      this.allDialogTab = ['media', 'docs', 'links'].includes(tab) ? tab : 'media'
      this.showAllDialog = true
    },
    handlePreviewThumb(item) {
      if (!item || (!this.isImage(item) && !this.isVideo(item))) return
      this.$emit('preview-media', item)
    },
    handleThumbClick(item) {
      if (!item) return
      if (this.isImage(item)) {
        const currentThumbs = Array.isArray(this.displayThumbList) ? this.displayThumbList : []
        const imageThumbs = currentThumbs.filter(it => this.isImage(it))

        const images = imageThumbs
          .map(it => ({ src: it?.url || it?.preview || '' }))
          .filter(it => !!it.src)

        const clickedSrc = item?.url || item?.preview || ''
        const initialViewIndex = Math.max(0, images.findIndex(it => it.src === clickedSrc))

        if (images.length === 0) return
        viewerApi({
          images,
          options: {
            initialViewIndex,
          },
        })
        return
      }
      if (this.isVideo(item)) {
        this.$emit('preview-media', item)
        return
      }

      if (this.isLink(item)) {
        const url = this.normalizeLinkUrl(item?.url || item?.text)
        if (!url) return
        window.open(url, '_blank', 'noopener')
        return
      }

      const url = String(item?.url || item?.text || '').trim()
      if (!url) return
      const ext = this.getFileExtFromNameOrUrl(item?.name || item?.title, url)
      if (this.isOfficePreviewableExt(ext)) {
        window.open(
          'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url)
        )
        return
      }

      window.open(url)
    },
    handleUserListScroll(e) {
      const target = e.target
      const scrollBottom = target.scrollTop + target.clientHeight
      // 滚动到底部附近时加载更多
      if (scrollBottom >= target.scrollHeight - 20) {
        this.loadMoreGroupMembers()
      }
    },
    loadMoreGroupMembers() {
      if (this.loadingGroupMembers || !this.groupMembersHasMore) return
      this.groupMembersPage += 1
      this.fetchGroupParticipants(this.room?.roomId, true)
    },
    fetchGroupParticipants(groupId, isLoadMore = false) {
      if (!groupId || this.loadingGroupMembers) return
      this.loadingGroupMembers = true

      const params = {
        groupId,
        limit: this.groupMembersLimit,
        offset: this.groupMembersPage,
				from: this.normalizeFromUsId(this.currentUserId)
      }

      getGroupParticipants(params)
        .then((res) => {
          const list = this.normalizeGroupParticipants(res)
          const hasMore = list.length === this.groupMembersLimit
          this.groupMembersHasMore = hasMore

          if (isLoadMore) {
            // 去重追加
            const existingIds = new Set(this.groupMembersList.map(m => m?.id?._serialized || m?.id?.user || m?.id))
            const newMembers = list.filter(m => {
              const id = m?.id?._serialized || m?.id?.user || m?.id
              return !existingIds.has(id)
            })
            this.groupMembersList = [...this.groupMembersList, ...newMembers]
          } else {
            this.groupMembersList = list
          }
        })
        .catch(() => {
          if (!isLoadMore) {
            this.groupMembersList = []
          }
        })
        .finally(() => {
          this.loadingGroupMembers = false
        })
    },
    normalizeGroupParticipants(res) {
      const payload = res?.result || res?.data?.result || res?.data || res
      if (Array.isArray(payload)) return payload
      if (Array.isArray(payload?.list)) return payload.list
      if (Array.isArray(payload?.rows)) return payload.rows
      if (Array.isArray(payload?.data)) return payload.data
      if (Array.isArray(payload?.participants)) return payload.participants
      return []
    },
    getMemberAdminBadge(member) {
      const role = member?.role
      if (role === 'superadmin') return this.$t('whatsapp.drawer.groupSuperAdmin')
      if (role === 'admin') return this.$t('whatsapp.drawer.groupAdmin')
      return ''
    },
    hasAdminBadge(member) {
      const role = member?.role
      return role === 'superadmin' || role === 'admin'
    },
    handleGroupAction(command) {
      switch (command) {
        case 'add-special':
          this.$message.info(this.$t('whatsapp.drawer.todo.addToSpecialAttention'))
          break
        case 'add-list':
          this.$message.info(this.$t('whatsapp.drawer.todo.addToList'))
          break
        case 'clear-chat':
          this.$emit('room-action-handler', { action: { name: 'clearChat' }, roomId: this.room?.roomId })
          break
        case 'exit-group':
          this.$emit('room-action-handler', { action: { name: 'leaveGroup' }, roomId: this.room?.roomId })
          break
        case 'report-group':
          this.$message.info(this.$t('whatsapp.drawer.todo.reportGroup'))
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.right {
  width: 400px;
  min-width: 400px;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;

  .bottom_scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .bottom {
    padding: 12px 20px 20px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .media-panel-wrapper {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    position: relative;

    :deep(.media-docs-links-panel) {
      height: 100%;
    }
  }

  .top_box {
    width: 100%;
    padding: 20px;
    min-height: 72px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f0f0f0;
    flex-shrink: 0;

    .title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #444444;
    }

    .btn_close {
      padding: 4px;
      border: none;
      background: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 14px;
        height: 14px;
        display: block;
      }
    }
  }

  .middle {
    padding: 30px 20px 24px;
    border-bottom: 1px solid #f0f0f0;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;

    .avatar_wrap {
      width: 120px;
      height: 120px;
      border-radius: 50%;
      overflow: hidden;
      flex-shrink: 0;

      .avatar {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        display: block;
      }

      .avatar_placeholder {
        width: 100%;
        height: 100%;
        background: #e8e8e8;
      }
    }

    .username {
      margin-top: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      text-align: center;
    }

    .userid {
      margin-top: 10px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #aaaaaa;
      text-align: center;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 6px;

      .displayid_loading {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        border: 2px solid rgba(170, 170, 170, 0.35);
        border-top-color: rgba(170, 170, 170, 0.9);
        box-sizing: border-box;
        animation: displayid_spin 0.8s linear infinite;
        flex: 0 0 auto;
      }
    }
  }

  @keyframes displayid_spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .bottom {
    flex: 1;
    min-height: 0;
    padding: 12px 20px 20px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    &.bottom--no-top-padding {
      padding-top: 0;
    }

		&.bottom--search {
			overflow: visible;
		}
  }
}

.contact-card {
  padding: 20px;
  background: #f8f8f8;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);

  .section_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    .section_title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #444444;
    }

    .section_count {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #aaaaaa;
    }
  }

  .thumb_list {
    display: flex;
    gap: 10px;

    .thumb_item {
      width: calc((100% - 20px) / 3);
      aspect-ratio: 1;
      border-radius: 4px;
      overflow: hidden;
      background: #e8e8e8;
      flex-shrink: 0;

      &.thumb_item_clickable {
        cursor: pointer;
      }

      .thumb_img {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        will-change: transform;
        transform: translateZ(0);
        backface-visibility: hidden;
      }

      .thumb_video {
        width: 100%;
        height: 100%;
        background: #d8d8d8;
        display: flex;
        align-items: center;
        justify-content: center;

        .play_icon {
          width: 32px;
          height: 32px;
        }
      }

      .thumb_file {
        width: 100%;
        height: 100%;
        background: #e8e8e8;
        padding: 8px;
        box-sizing: border-box;

        .thumb_file_content {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          gap: 8px;
          min-width: 0;
        }

        .thumb_file_icon {
          width: 28px;
          height: 28px;
          flex: 0 0 28px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .thumb_link_icon {
          width: 35px;
          height: 35px;
          flex: 0 0 35px;
        }

        .thumb_link_favicon {
          width: 35px;
          height: 35px;
          object-fit: contain;
          display: block;
        }

        .thumb_file_main {
          min-width: 0;
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .thumb_file_title {
          font-size: 12px;
          line-height: 16px;
          color: #444;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .thumb_file_sub {
          font-size: 12px;
          line-height: 16px;
          color: #999;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
.group_user_list_settings{
  margin-top: 20px;
  width: 100%;
  padding: 0 20px 16px;
  box-sizing: border-box;

  .user_list {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding-top: 8px;
    height: auto;
  }

  .member_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .member_left {
    display: flex;
    align-items: center;
    min-width: 0;
    gap: 12px;
  }

  .member_avatar_wrap {
    width: 42px;
    height: 42px;
    flex: 0 0 42px;
  }

  .member_avatar,
  .member_avatar_placeholder {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    overflow: hidden;
  }

  .member_avatar_placeholder {
    background: #f1f1f1;
    border: 1px solid #e7e7e7;
  }

  .member_text {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .member_name {
    font-size: 16px;
    line-height: 20px;
    color: #111;
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .member_sub {
    font-size: 12px;
    line-height: 16px;
    color: #8c8c8c;
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .member_right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;
    flex: 0 0 auto;
  }

  .member_admin_badge {
    padding: 2px 10px;
    border-radius: 12px;
    background: #e9f7ea;
    color: #2a7b2e;
    font-size: 12px;
    line-height: 18px;
    white-space: nowrap;
  }

  .member_id {
    font-size: 13px;
    line-height: 18px;
    color: #666;
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .setting_tool {
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #f0f0f0;
  }

  .action_list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .action_item {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
    border-radius: 6px;
    transition: background-color 0.2s ease;

    &:hover {
      background: #f5f5f5;
    }

    &.danger {
      .action_icon,
      .action_text {
        color: #b0324a;
      }
    }
  }

  .action_icon {
    width: 20px;
    height: 20px;
    margin-right: 12px;
    color: #333;
    flex-shrink: 0;
  }

  .action_text {
    font-size: 13px;
    color: #333;
    flex: 1;
  }
}

.vac-avatar-image {
  border-radius: 50%;
}

.vac-avatar-image :deep(img) {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

// Drawer 头部头像样式
.vac-avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
